"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconFilePDF = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M13,9 L18.5,9 L13,3.5 L13,9 M6,2 L14,2 L20,8 L20,20 C20,21.1045695 19.1045695,22 18,22 L6,22 C4.8954305,22 4,21.1045695 4,20 L4,4 C4,2.8954305 4.8954305,2 6,2 M10.1,11.4 C10.08,11.44 9.81,13.16 8,16.09 C8,16.09 4.5,17.91 5.33,19.27 C6,20.35 7.65,19.23 9.07,16.59 C9.07,16.59 10.89,15.95 13.31,15.77 C13.31,15.77 17.17,17.5 17.7,15.66 C18.22,13.8 14.64,14.22 14,14.41 C14,14.41 12,13.06 11.5,11.2 C11.5,11.2 12.64,7.25 10.89,7.3 C9.14,7.35 9.8,10.43 10.1,11.4 M10.91,12.44 C10.94,12.45 11.38,13.65 12.8,14.9 C12.8,14.9 10.47,15.36 9.41,15.8 C9.41,15.8 10.41,14.07 10.91,12.44 M14.84,15.16 C15.42,15 17.17,15.31 17.1,15.64 C17.04,15.97 14.84,15.16 14.84,15.16 M7.77,17 C7.24,18.24 6.33,19 6.1,19 C5.87,19 6.8,17.4 7.77,17 M10.91,10.07 C10.91,10 10.55,7.87 10.91,7.92 C11.45,8 10.91,10 10.91,10.07 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconFilePDF')(IconFilePDF);